module.exports = __webpack_public_path__ + "img/banner_home.85bf19d2.png";